export const initProductPage = () => {
  const productPage = document.querySelector(".product-page");

  if (productPage) {
    /**
     * Show-More function on table
     */
    const showMoreButton = document.getElementById("show-more-button");
    const nutritionRows = document.querySelectorAll(".nutrition-row");

    if (showMoreButton) {
      showMoreButton.addEventListener("click", () => {
        for (let i = 0; i < nutritionRows.length; i++) {
          if (i >= 10) {
            nutritionRows[i].classList.toggle("hidden");
          }
        }
  
        showMoreButton.classList.toggle("show--active")
      });

      /**
     * Adjust hight on load for both columns
     */
    const layoutElement = document.querySelector('.layout');
    const pictureSectionElement = document.querySelector('.picture-section__picture') as HTMLElement;

    // Check if both elements exist
    if (layoutElement && pictureSectionElement) {
      const minWidth = 800; // Minimum screen width in pixels

      // Function to check screen width and set height
      const setHeightBasedOnScreenWidth = () => {
        if (window.innerWidth > minWidth) {
          const layoutHeight = layoutElement.clientHeight;
          pictureSectionElement.style.height = `${layoutHeight}px`;
        } else {
          // Reset the height if the screen width is smaller than 1112px
          pictureSectionElement.style.height = 'auto';
        }
      };

      // Initial call to set the height based on the current screen width
      setHeightBasedOnScreenWidth();

      // Add an event listener to recheck when the window is resized
      window.addEventListener('resize', setHeightBasedOnScreenWidth);
    }
    }

    
  }
};